const price = (num, afterPointNum = 0) => {
  return `$${parseFloat(num).toFixed(afterPointNum)}`
};

export default price;